import { createContext } from 'react'
import type { AvatarDetails } from '~/types/avatar'
import type { EmoteDetails } from '~/types/emote'

/**
 * デフォルトアバター情報
 */
export interface DefaultAvatarInfo {
  vrmUrl: string
  ownerUserId: string
  version: number
}

export interface AppConfigContextValue {
  /** デフォルトアバター情報 */
  defaultAvatar: DefaultAvatarInfo | null
  /** 設定読み込み中 */
  isLoading: boolean
  /** エラーメッセージ */
  error: string | null
  /** 元のAPIレスポンス（詳細情報が必要な場合用） */
  rawDefaultAvatar: AvatarDetails | null
  /** デフォルト（システム）エモート。全ユーザー・ゲストが再生可能 */
  defaultEmotes: EmoteDetails[]
}

const DEFAULT_VALUE: AppConfigContextValue = {
  defaultAvatar: null,
  isLoading: true,
  error: null,
  rawDefaultAvatar: null,
  defaultEmotes: [],
}

export const AppConfigContext = createContext<AppConfigContextValue>(DEFAULT_VALUE)
